var map = {
	"./logo-aica-hotel.png": "1fb7",
	"./logo-aica.png": "e03c",
	"./logo-amica.png": "163c",
	"./logo-astanet.png": "d451",
	"./logo-baltycka.png": "cfab",
	"./logo-centrum-riviera.svg": "aa3f",
	"./logo-galeria-lodzka.png": "bd8f",
	"./logo-galeria-pomorska.png": "7ef5",
	"./logo-goodfood.png": "f690",
	"./logo-hotel-bialy-kamien.png": "9c28",
	"./logo-lira.png": "af04",
	"./logo-pasaz-grunwaldzki.png": "8fbb",
	"./logo-valo-motion.png": "5890"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6d4";